import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, Form, FormGroup, FormFeedback} from 'reactstrap'
import PropTypes from 'prop-types'
import CreatableSelect from '../../../Wps/CreatableSelect'

export default class InspectionCategoryModal extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      inspection_category_id: null
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    inspCatList: PropTypes.array.isRequired,
    weldData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
  }

  handleSubmit(e) {
    e.preventDefault()

    let categoryId = this.state.inspection_category_id ? this.state.inspection_category_id.id : null
    if (Array.isArray(this.props.weldData)) {
      this.props.onSubmit(categoryId, this.props.weldData)
    } else {
      this.props.onSubmit(categoryId)
    }
  }

  render() {
    return (
      <Modal isOpen={true}>
        <ModalHeader>Inspection Category {Array.isArray(this.props.weldData) ? `(${this.props.weldData.length} welds)` : ''}</ModalHeader>
        <ModalBody>
          <Form id="welds-grid-inspection-category-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
            {Array.isArray(this.props.weldData) && (
              <FormFeedback>Assigning inspection category to {this.props.weldData.length} selected welds</FormFeedback>
            )}
            <CreatableSelect
              id="select-inspection-category-form"
              options={this.props.inspCatList.map(cat => ({
                name: cat.name,
                id: cat.id
              }))}
              valueKey="id"
              value={this.state.inspection_category_id}
              multi={false}
              creatable={false}
              valueChangeFunction={cat => this.setState({inspection_category_id: cat})}
            />
            <FormGroup>
              <hr/>
              <Button id="cancel-inspection-category-form-btn" className="float-right" color="danger"
                onClick={this.props.onCancel}>Cancel</Button>
              <Button id="save-inspection-category-form-btn" className="float-right" color="primary" type="submit">OK</Button>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Welds/helpers/wps/InspectionCategoryModal.js